const CACHE_PREFIX = 'bt_products:';
const DEFAULT_TTL_MS = 5 * 60 * 1000;

export const makeCacheKey = (prefix, params) => {
  if (!params) return `${CACHE_PREFIX}${prefix}`;
  const entries = Object.entries(params)
    .filter(([, value]) => value !== undefined && value !== null && value !== '')
    .sort(([a], [b]) => a.localeCompare(b));
  const query = entries.map(([key, value]) => `${key}=${value}`).join('&');
  return `${CACHE_PREFIX}${prefix}?${query}`;
};

export const readCache = (key, ttlMs = DEFAULT_TTL_MS) => {
  try {
    const raw = sessionStorage.getItem(key);
    if (!raw) return null;
    const parsed = JSON.parse(raw);
    if (!parsed || !parsed.ts) return null;
    if (Date.now() - parsed.ts > ttlMs) return null;
    return parsed.data ?? null;
  } catch (error) {
    return null;
  }
};

export const writeCache = (key, data) => {
  try {
    sessionStorage.setItem(key, JSON.stringify({ ts: Date.now(), data }));
  } catch (error) {
    // Ignore storage errors (quota, privacy mode)
  }
};
